/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { WithConfig } from "ng-zorro-antd/core/config";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzCollapseComponent } from "ng-zorro-antd/collapse";
import { Component, Input } from "@angular/core";

@Component({
  selector: "ui-collapse",
  exportAs: "uiCollapse",
  templateUrl: "./collapse.component.html",
  styleUrls: ["./collapse.component.less"],
})
export class UiCollapseComponent extends NzCollapseComponent {
  @Input("collapseAccordion") @WithConfig() @InputBoolean() public nzAccordion = false;
  @Input("collapseBordered") @WithConfig() @InputBoolean() public nzBordered = true;
  @Input("collapseGhost") @WithConfig() @InputBoolean() public nzGhost = false;
  @Input("collapseExpandIconPosition") public nzExpandIconPosition: "left" | "right" = "left";
}
